import { envConfig } from '@/js/constants';
export var localPaginationMixin = {
  data: function data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: envConfig.pagintaionSize,
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0
      },
      pagination2: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0
      }
    };
  }
};